import axios, { Method, AxiosResponse, AxiosError } from "axios";
import Cookies from "js-cookie";
import { isAccessTokenExpired, refreshAccessToken } from "../../config/auth/useRefreshToken";
import { removeCookie } from "../../../utils/setCookie";
import PUBLIC_ENDPOINTS from "./constants";

let isRedirecting = false;

const redirectOnce = (redirectUrl: string): void => {
  if (isRedirecting) return;
  isRedirecting = true;
  window.location.replace(redirectUrl);
};

const ensureValidToken = async (): Promise<string | null> => {
  let token = Cookies.get("auth_token");
  if (!token || isAccessTokenExpired(token)) {
    const refreshedToken = await refreshAccessToken();
    
    if (!refreshedToken) {
      return null;
    }
    
    token = refreshedToken;
  }
  
  return token;
};

export const initializeTokenValidation = async (): Promise<boolean> => {
  try {
    const refreshToken = Cookies.get("refresh_token");
    if (!refreshToken) {
      return false;
    }

    const token = Cookies.get("auth_token");

    if (!token || isAccessTokenExpired(token)) {
      const newToken = await refreshAccessToken();
      const isValid = !!newToken;

      return isValid;
    }

    return true; 
  } catch (error) {
    console.error("Error during token validation:", error);
    removeCookie("auth_token");
    removeCookie("refresh_token");
    return false;
  }
};
// Register interceptors once at module load time, not inside callApi
axios.interceptors.request.use(
  async (req) => {
    if (req.url && PUBLIC_ENDPOINTS.some(endpoint => req.url?.includes(endpoint))) {
      return req;
    } else {
      const validToken = await ensureValidToken();
      if (validToken && req.headers) {
        (req.headers as any).Authorization = `Bearer ${validToken}`;
      }
    }

    return req;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res: AxiosResponse) => {
    return res;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config as any;
    const currentPagePath = window.location.pathname
    console.log(currentPagePath)
    console.log(originalRequest)
    console.log( PUBLIC_ENDPOINTS.some(endpoint => currentPagePath?.includes(endpoint)))
    const isPublicEndpoint = originalRequest?.url && (
      PUBLIC_ENDPOINTS.some(endpoint => currentPagePath?.includes(endpoint)) ||
      PUBLIC_ENDPOINTS.some(endpoint => originalRequest?.url?.includes(endpoint))
    );
    if (error.response?.status === 401 && !originalRequest._retry && !isPublicEndpoint) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken();
        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axios(originalRequest);
        } else {
          // redirectOnce('/sign-in');
          return Promise.reject(error);
        }
      } catch (refreshError) {
        // redirectOnce('/sign-in');
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function callApi(url: string, method: Method, data?: any, config?: any) {
  const token = Cookies.get("auth_token");

  const headers: any = {
    Authorization: `Bearer ${token}`,
  };

  return axios({
    url,
    method,
    headers,
    data,
    ...config,
  });
}
